import React from 'react';
import './services.css';
import { useTranslation } from './LanguageContext';

export default function Asavoir() {
  const { t } = useTranslation();
  const sanctions = t('asavoir.sanctions.items');
  const refs = t('asavoir.refs.items');
  return (
    <section id="asavoir" className="section asavoir">
      <div className="container">
        <div className="feature-icon" >
          <img src="/icons/protection.png" alt="info" loading="lazy" style={{width: '80px', aspectRatio: '1', objectFit: 'contain',marginBottom:"10px",margin:"0 auto",}} />
          <div className="section-title">
            <h2>{t('asavoir.title')}</h2>
          </div>
        </div>
        <div className="asavoir_cart" >
          <h3 style={{textAlign:"center",}}>{t('asavoir.heading')}</h3>
          <p>{t('asavoir.p1')}</p>
          <p>{t('asavoir.format')}</p>
        </div>
        <div className='asavoir_cart'>
            <h4 style={{marginTop: '0.75rem',textAlign:"center"}}>{t('asavoir.examen.title')}</h4>
            <p>{t('asavoir.examen.p')}</p>
            <p>{t('asavoir.proc.p')}</p>            
          </div>
        
      </div>
    </section>
  );
}
